<template>
  <div class="add-store">
    <v-container>
      <v-row>
        <v-col cols="12">
          <StoreDataForm />
          <v-alert
            v-if="error"
            color="red"
            icon="mdi-alert-circle-outline"
            text
          >
            Der Eintrag konnte nicht erstellt werden (siehe Konsole)!
          </v-alert>
          <v-btn v-on:click="create" color="primary white--text" block depressed
            >Erstellen</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import StoreDataForm from "@/components/store/StoreDataForm";

export default {
  name: "AddStore",

  components: {
    StoreDataForm
  },

  data: () => ({
    error: false
  }),

  methods: {
    create: function() {
      let that = this;
      this.$store
        .dispatch("storeEditor/create")
        .then(createdStoreId =>
          this.$navigateTo("Store", { storeId: createdStoreId })
        )
        .catch(e => {
          console.error(e);
          that.error = true;
        });
    }
  }
};
</script>
